module.exports = __webpack_public_path__ + "static/media/cancel.844f6d55.png";